import _ from "lodash";

export function find_new_code(code, fields) {
  var minNumber = 0;
  var lastNumber = null;

  const matched = code.match(/(\d+)(?!.*\d)$/);
  if (matched) {
    lastNumber = matched[0];

    if (lastNumber) {
      minNumber = parseInt(lastNumber);
    }
  }

  var isOk = false;
  var newCode = code + minNumber;
  while (!isOk) {
    minNumber = minNumber + 1;

    if (lastNumber)
      // replace exisiting number
      newCode = code.replace(lastNumber, minNumber + "");

    var found = _.find(fields, { code: newCode });
    if (!found) {
      isOk = true;
    }
  }

  return newCode;
}

// From https://stackoverflow.com/a/8472700/150953
export var generateGUID =
  typeof window.crypto != "undefined" &&
  typeof window.crypto.getRandomValues != "undefined"
    ? function () {
        // If we have a cryptographically secure PRNG, use that
        // https://stackoverflow.com/questions/6906916/collisions-when-generating-uuids-in-javascript
        var buf = new Uint16Array(8);
        window.crypto.getRandomValues(buf);
        var S4 = function (num) {
          var ret = num.toString(16);
          while (ret.length < 4) {
            ret = "0" + ret;
          }
          return ret;
        };
        return (
          S4(buf[0]) +
          S4(buf[1]) +
          "-" +
          S4(buf[2]) +
          "-" +
          S4(buf[3]) +
          "-" +
          S4(buf[4]) +
          "-" +
          S4(buf[5]) +
          S4(buf[6]) +
          S4(buf[7])
        );
      }
    : function () {
        // Otherwise, just use Math.random
        // https://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
        return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
          /[xy]/g,
          function (c) {
            var r = (Math.random() * 16) | 0,
              v = c == "x" ? r : (r & 0x3) | 0x8;
            return v.toString(16);
          }
        );
      };

export function isDisabled(item, field_code, disabled) {
  if (item && "__disabled" in item) {
    var result = false;
    // if all exists, default to that
    if ("__all" in item["__disabled"]) {
      result = !!item["__disabled"]["__all"];
    }

    // If there is an Entry for THIS field code then use that value
    // Allows us to disable one field while rest enabled etc.
    if (field_code in item["__disabled"]) {
      result = !!item["__disabled"][field_code];
    }
    return result || disabled;
  }

  return disabled;
}
